import { Suspense, useMemo } from "react";
import { tokens } from "marvin-auth-kit/dist/tokens";
import { ErrorBoundary } from "react-error-boundary";

import {
  ExtendedWMSParams,
  LayerWMS,
  IndicatorSelection,
  LayerProperties,
  Layer,
} from "types";

import { useIndicator } from "hooks/indicatorHooks";
import { useSelectedLayer } from "hooks/selectionHooks";

import { WMSHeaderTileLayer } from "./WMSHeaderTileLayer";

interface Props {
  config: string;
  layerProperties: LayerProperties[];
  selection: IndicatorSelection;
  zIndex: number;
}

export function MapWMSLayer(props: Props) {
  const { config, layerProperties, selection, zIndex } = props;
  const { data: indicator } = useIndicator(
    config,
    selection.indicatorId,
    layerProperties
  );

  const { data: layer } = useSelectedLayer(config, indicator, layerProperties);
  const headers = getAuthorizationHeader(layer);

  const params = useMemo(
    () => (layer ? toWMSParams(layer.wms) : ({} as ExtendedWMSParams)),
    [layer]
  );

  function toWMSParams(wms: LayerWMS): ExtendedWMSParams {
    return {
      format: wms.format,
      layers: wms.layers || "",
      service: "WMS",
      styles: wms.styles,
      version: "1.1.1",
      transparent: true,
      tiled: true,
    };
  }

  function getAuthorizationHeader(layer: Layer | undefined) {
    const { token } = tokens.get();
    const domain = `${window.location.protocol}//${window.location.hostname}`;
    if (
      token &&
      layer &&
      (layer.wms.url.startsWith(domain) || layer.wms.url.startsWith("/"))
    )
      return { Authorization: `Bearer ${token}` };
    return {};
  }

  return (
    <>
      {layer && (
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <WMSHeaderTileLayer
              key={`wms-${layer.id}`}
              url={layer.wms.url}
              params={params}
              opacity={selection.opacity}
              zIndex={zIndex}
              headers={headers}
            />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}
